import { render, staticRenderFns } from "./BuildingCodeCategoryList.vue?vue&type=template&id=9f375c1e&"
import script from "./BuildingCodeCategoryList.vue?vue&type=script&lang=js&"
export * from "./BuildingCodeCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports